import React from "react";
import HomeYieldGraph from "../../assets/img/home-yield.png";
import HomeYieldGraphBg from "../../assets/img/home-yield-bg.png";
import { ActiveIcon, BoundingBoxIcon, GraphUpIcon, ShieldIcon } from "../SVGIcons";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";

const Item = ({ label, icon, className }: { label: string, icon: React.ReactNode, className: string }) => {
    return <div className={clsx(
        "absolute p-[12px] flex gap-[6px] items-center bg-white/10 rounded-[12px] backdrop-blur-[40px]",
        "md:p-[16px] md:gap-[8px]",
        className
    )}>
        {icon}
        <div className={clsx(
            "text-[15px] font-medium leading-[1.2] tracking-[-0.8px]",
            "md:text-[20px]"
        )}>
            {label}
        </div>
    </div>
}
const YieldGraph = () => {
    return <div className={clsx(
        "pt-[40px] pb-[60px] flex flex-col items-center gap-[40px] relative border-b border-[#161616] px-[16px]",
        "md:pt-[120px] md:pb-[120px]"
    )}>
        <div className={clsx(
            "capitalize text-[32px] font-semibold leading-[1.2] tracking-[-1.84px] text-center relative z-[2]",
            "md:text-[46px]"
        )}>
            <AnimatedContent>
                The all-in-one engine for TAO yield <br />x  and leveraged alpha
            </AnimatedContent>
        </div>

        <div className="relative z-[2]">
            <img src={HomeYieldGraph} alt="home-yield" className="w-full h-full max-w-[720px] object-cover" />
            <Item
                label="Deposit TAO"
                icon={<div>
                    <GraphUpIcon fillColor="#00FFEE" className="w-[32px] h-[32px]" />
                </div>}
                className={clsx(
                    "left-[-10px] top-[30px] animate-breathe",
                    "md:left-[-100px] md:top-[100px]"
                )}
            />
            <Item
                label="Capital Efficiency"
                icon={<div>
                    <BoundingBoxIcon fillColor="#00FFEE" className="w-[32px] h-[32px]" />
                </div>}
                className={clsx(
                    "left-[16px] bottom-[40px] animate-breathe [animation-delay:0.75s]",
                    "md:left-[-93px] md:bottom-[100px]"
                )}
            />
            <Item
                label="Leverage"
                icon={<div>
                    <ActiveIcon fillColor="#00FFEE" className="w-[32px] h-[32px]" />
                </div>}
                className={clsx(
                    "right-[0px] top-[60px] animate-breathe [animation-delay:1.5s]",
                    "md:right-[-43px] md:top-[120px]"
                )}
            />
            <Item
                label="Safety"
                icon={<div>
                    <ShieldIcon fillColor="#00FFEE" className="w-[32px] h-[32px]" />
                </div>}
                className={clsx(
                    "right-[-10px] bottom-[-20px] animate-breathe [animation-delay:2.25s]",
                    "md:right-[-100px] md:bottom-[120px]"
                )}
            />
        </div>
        <img src={HomeYieldGraphBg} alt="home-yield" className="w-full h-full absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] object-cover max-w-[1440px]" />
    </div>;
};

export default YieldGraph;
